module.exports = __webpack_public_path__ + "img/applicant.e32f8804.jpg";